import { render, staticRenderFns } from "./markRecordDetails.vue?vue&type=template&id=5845d348&scoped=true&"
import script from "./markRecordDetails.vue?vue&type=script&lang=js&"
export * from "./markRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./markRecordDetails.vue?vue&type=style&index=0&id=5845d348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845d348",
  null
  
)

export default component.exports